import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, Checkbox, FormControl, FormLabel, Input, Textarea} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useBan, useBanStatus} from "../../../api/moderation";

const BanSheet = styled(({className, community, username, onClose}) => {

    const {feedbackCh} = useFeedback();
    const banStatus = useBanStatus(feedbackCh,  username, community)?.banned;
    const [days, setDays] = useState('0');
    const [reason, setReason] = useState('');
    const [nuke, setNuke] = useState(false);
    const [ipBan, setIpBan] = useState(false);
    const ban = useBan(feedbackCh);
    const handleBan = async () => {
        try {
            await ban(username, community, reason, days ? days : 0, nuke, ipBan);
        } catch {}
        onClose();
    };

        return (
            <div className={className}>

                <Header>
                    <Title>Ban</Title>
                </Header>

                <FormControl>
                    <FormLabel>Days</FormLabel>
                    <Input placeholder="0" value={days} onChange={(e) => setDays(e.currentTarget.value)}/>
                </FormControl>

                <FormControl pt={4}>
                    <FormLabel>Violation</FormLabel>
                    <Textarea value={reason} onChange={(e) => setReason(e.currentTarget.value)}/>
                </FormControl>

                <FormControl pt={4}>
                    <Checkbox size='md' value={nuke} isChecked={nuke}
                              onChange={(e) => setNuke(e.target.checked)}>Nuke Content</Checkbox>
                </FormControl>

                <FormControl pt={2}>
                    <Checkbox size='md' value={ipBan} isChecked={ipBan}
                              onChange={(e) => setIpBan(e.target.checked)}>IP Ban</Checkbox>
                </FormControl>

                <Button variant={"grey"} style={{width: '100%'}} mt={6} onClick={handleBan}>Save</Button>

            </div>
        );
    }
)`
    p {
      font-size: 17px;
    }
`;

export default BanSheet;
